import { GalleryItemProps } from '../components/MasonryGrid/types'

export const distributeImages = (items: GalleryItemProps[], columnCount: number): number[][] => {
  const columns: number[][] = Array.from({ length: columnCount }, () => [])

  for (let index = 0; index < items.length; index++) {
    const columnIndex = index % columnCount

    columns[columnIndex].push(index)
  }

  return columns
}
